export default {
      id: "close-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#close",
      toString: function () {
        return this.url;
      }
    }